import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface OrdenTrabajoLinkProps {
  ordenId?: string | null;
  numeroOt?: string;
  titulo?: string;
  showButton?: boolean;
  className?: string;
}

export const OrdenTrabajoLink: React.FC<OrdenTrabajoLinkProps> = ({
  ordenId,
  numeroOt,
  titulo,
  showButton = true,
  className = ""
}) => {
  const navigate = useNavigate();

  if (!ordenId) {
    return (
      <span className={`text-muted-foreground text-sm ${className}`}>
        Trabajo independiente
      </span>
    );
  }

  const handleNavigation = () => {
    navigate('/ordenes-trabajo', { state: { highlightOrden: ordenId } });
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex flex-col">
        {numeroOt && (
          <Badge variant="outline" className="font-mono text-xs">
            {numeroOt}
          </Badge>
        )}
        {titulo && (
          <span className="text-sm text-muted-foreground truncate max-w-[200px]" title={titulo}>
            {titulo}
          </span>
        )}
      </div>
      {showButton && (
        <Button
          size="sm"
          variant="ghost"
          onClick={handleNavigation}
          className="h-6 w-6 p-0"
        >
          <ExternalLink className="h-3 w-3" />
        </Button>
      )}
    </div>
  );
};